import planning from './planning/ms'

export default {
  nav: {
    dashboard: 'Papan Pemuka',
    projects: 'Projek',
    maps: 'Peta',
    data: 'Data',
    analytics: 'Analitik',
    settings: 'Tetapan',
    profile: 'Profil',
    team: 'Pasukan',
    billing: 'Pengebilan',
    apiKeys: 'Kunci API',
  },
  dashboard: {
    title: 'Papan Pemuka',
    overview: 'Gambaran Keseluruhan',
    recentActivity: 'Aktiviti Terkini',
    quickStats: 'Statistik Pantas',
    totalProjects: 'Jumlah Projek',
    totalMaps: 'Jumlah Peta',
    totalUsers: 'Jumlah Pengguna',
    storageUsed: 'Storan Digunakan',
  },
  projects: {
    title: 'Projek',
    createProject: 'Buat Projek',
    myProjects: 'Projek Saya',
    sharedProjects: 'Projek Dikongsi',
    archivedProjects: 'Projek Diarkib',
    projectName: 'Nama Projek',
    description: 'Penerangan',
    createdAt: 'Dicipta',
    updatedAt: 'Kemaskini Terakhir',
    owner: 'Pemilik',
    members: 'Ahli',
    noProjects: 'Tiada projek dijumpai',
    deleteProject: 'Padam Projek',
    archiveProject: 'Arkib Projek',
    restoreProject: 'Pulihkan Projek',
  },
  maps: {
    title: 'Peta',
    createMap: 'Buat Peta',
    myMaps: 'Peta Saya',
    sharedMaps: 'Peta Dikongsi',
    mapName: 'Nama Peta',
    mapType: 'Jenis Peta',
    layers: 'Lapisan',
    addLayer: 'Tambah Lapisan',
    removeLayer: 'Buang Lapisan',
    exportMap: 'Eksport Peta',
    shareMap: 'Kongsi Peta',
  },
  data: {
    title: 'Data',
    uploadData: 'Muat Naik Data',
    importData: 'Import Data',
    exportData: 'Eksport Data',
    dataSource: 'Sumber Data',
    dataSources: 'Sumber Data',
    dataset: 'Set Data',
    datasets: 'Set Data',
    records: 'Rekod',
    columns: 'Lajur',
    preview: 'Pratonton',
  },
  analytics: {
    title: 'Analitik',
    reports: 'Laporan',
    createReport: 'Buat Laporan',
    viewReport: 'Lihat Laporan',
    exportReport: 'Eksport Laporan',
    spatialAnalysis: 'Analisis Spatial',
    statistics: 'Statistik',
    trends: 'Trend',
    insights: 'Insight',
  },
  settings: {
    title: 'Tetapan',
    general: 'Am',
    account: 'Akaun',
    security: 'Keselamatan',
    notifications: 'Notifikasi',
    preferences: 'Pilihan',
    language: 'Bahasa',
    timezone: 'Zon Masa',
    appearance: 'Penampilan',
    theme: 'Tema',
    lightMode: 'Mod Cerah',
    darkMode: 'Mod Gelap',
    systemDefault: 'Lalai Sistem',
  },
  team: {
    title: 'Pasukan',
    inviteMember: 'Jemput Ahli',
    members: 'Ahli',
    pending: 'Jemputan Tertangguh',
    role: 'Peranan',
    admin: 'Pentadbir',
    member: 'Ahli',
    viewer: 'Penonton',
    removeMember: 'Buang Ahli',
    changeRole: 'Tukar Peranan',
  },
  billing: {
    title: 'Pengebilan & Langganan',
    subtitle: 'Urus langganan, baki kredit dan kerusi anda.',
    loading: 'Memuatkan langganan…',
    nav: 'Pengebilan & Langganan',
    currentPlan: 'Pelan Semasa',
    usage: 'Penggunaan',
    invoices: 'Invois',
    paymentMethod: 'Kaedah Pembayaran',
    updatePayment: 'Kemaskini Kaedah Pembayaran',
    upgradePlan: 'Naik Taraf Pelan',
    downgradePlan: 'Turun Taraf Pelan',
    cancelSubscription: 'Batal Langganan',
    subscription: {
      title: 'Langganan',
      cadence: 'Kadens pengebilan',
      seats: 'Kerusi',
      seatsBreakdown: '{{admin}} pentadbir · {{publisher}} penerbit · {{viewer}} penonton',
      periodEnd: 'Tempoh semasa berakhir',
      trialEnd: 'Percubaan berakhir',
      cancelAtPeriodEnd: 'Langganan ini dijadualkan untuk dibatalkan pada akhir tempoh semasa.',
      endedOn: 'Langganan anda telah tamat pada {{date}}.',
    },
    cancel: {
      button: 'Batalkan langganan',
      confirmTitle: 'Batalkan langganan?',
      confirmBody:
        'Langganan anda kekal aktif sehingga {{date}}, kemudian dibatalkan. Anda mengekalkan akses penuh sehingga ketika itu.',
      confirmCta: 'Batalkan langganan',
      keep: 'Kekalkan langganan',
      reasonLabel: 'Mengapa anda membatalkan? (pilihan)',
      notePlaceholder: 'Ada lagi? (pilihan)',
      success: 'Langganan anda akan dibatalkan pada akhir tempoh.',
      reasons: {
        too_expensive: 'Terlalu mahal',
        missing_features: 'Ciri tidak mencukupi',
        switching: 'Beralih ke produk lain',
        no_longer_needed: 'Tidak diperlukan lagi',
        other: 'Lain-lain',
      },
    },
    reactivate: {
      button: 'Aktifkan semula langganan',
      success: 'Langganan anda telah diaktifkan semula.',
    },
    balance: {
      title: 'Baki kredit',
      credits: 'kredit',
      reserved: '{{count}} ditempah',
    },
    seats: {
      title: 'Kerusi',
      save: 'Simpan kerusi',
      admin: 'Pentadbir',
      publisher: 'Penerbit',
      viewer: 'Penonton',
    },
    topup: {
      title: 'Tambah kredit',
      blockCount: 'Blok',
      blockHelper: '= {{credits}} kredit',
      buy: 'Tambah',
      charged: 'Kredit berjaya ditambah.',
    },
    portal: {
      button: 'Urus pengebilan',
    },
    empty: {
      title: 'Tiada langganan aktif',
      body: 'Organisasi anda belum mempunyai langganan aktif.',
    },
    outOfCredits: {
      title: 'Kehabisan kredit',
      body: 'Tindakan ini memerlukan lebih banyak kredit daripada yang ada pada organisasi anda buat masa ini.',
      shortfall: 'Kekurangan',
      balance: 'Baki semasa',
      askAdmin: 'Minta pentadbir organisasi anda menambah kredit.',
      dismiss: 'Tutup',
      topUp: 'Tambah',
    },
  },
  signup: {
    title: 'Cipta ruang kerja anda',
    subtitle: 'Mulakan percubaan percuma 14 hari anda.',
    orgName: 'Nama organisasi',
    subdomain: 'Alamat ruang kerja',
    email: 'E-mel pentadbir',
    seats: 'Kerusi',
    seatsAdmin: 'Pentadbir',
    seatsPublisher: 'Penerbit',
    seatsViewer: 'Penonton',
    planSummary: 'Pelan per-kerusi · {{cadence}}',
    cadenceMonthly: 'Bulanan',
    cadenceAnnual: 'Tahunan',
    submit: 'Teruskan ke pembayaran',
    submitting: 'Memulakan pembayaran…',
    haveAccount: 'Sudah mempunyai akaun?',
    signIn: 'Log masuk',
    available: 'Tersedia',
    checking: 'Menyemak…',
    errors: {
      subdomainFormat: 'Gunakan huruf kecil, nombor dan tanda sempang (3–63 aksara)',
      subdomainReserved: 'Alamat itu telah dikhaskan — pilih yang lain',
      subdomainTaken: 'Alamat itu tidak tersedia — pilih yang lain',
      emailTaken: 'E-mel itu tidak boleh digunakan untuk pendaftaran baharu',
      startFailed: 'Tidak dapat memulakan pembayaran. Sila cuba lagi.',
    },
    success: {
      provisioning: 'Sedang menyediakan ruang kerja anda…',
      provisioningHint: 'Ini biasanya mengambil masa kurang seminit.',
      readyTitle: 'Ruang kerja anda telah sedia',
      readyBody: 'Kami menghantar jemputan log masuk ke {{email}}. Buka untuk menetapkan kata laluan anda.',
      goToLogin: 'Pergi ke log masuk',
      failedTitle: 'Sesuatu telah berlaku',
      failedBody: 'Kami tidak dapat menyelesaikan penyediaan ruang kerja anda. Sila hubungi sokongan.',
      timeoutBody: 'Masih menyelesaikan — semak e-mel anda untuk jemputan, kemudian log masuk.',
    },
  },
  groups: {
    title: 'Kumpulan',
    subtitle: 'Urus kumpulan pengguna dan perkongsian',
    create: 'Cipta Kumpulan',
    name: 'Nama',
    description: 'Penerangan',
    members: 'Ahli',
    actions: 'Tindakan',
    edit: 'Sunting',
    delete: 'Padam',
    deleteGroup: 'Padam kumpulan',
    deleteConfirm: 'Padam kumpulan ini? Sumber yang dikongsi dengannya tidak lagi boleh diakses oleh ahlinya.',
    save: 'Simpan',
    cancel: 'Batal',
    noGroupsTitle: 'Belum ada kumpulan',
    noGroupsBody:
      'Setelah anda mencipta kumpulan, kongsi sumber dengannya melalui butang Kongsi pada mana-mana peta, papan pemuka atau lapisan.',
    addMember: 'Cari pengguna mengikut nama atau e-mel...',
    removeMember: 'Buang ahli',
    nameRequired: 'Nama diperlukan',
    myGroupsTitle: 'Kumpulan Saya',
    myGroupsHelp: 'Kumpulan yang anda sertai. Hubungi pentadbir anda untuk menyertai atau meninggalkan kumpulan.',
    myGroupsEmpty: 'Anda belum menjadi ahli mana-mana kumpulan.',
  },
  forms: {
    title: 'Borang',
    subtitle: 'Bina borang yang mengumpul data terus ke dalam lapisan anda',
    newForm: 'Borang baharu',
    empty: 'Tiada borang lagi',
    emptyBody: 'Cipta borang pertama anda untuk mula mengumpul data lapangan.',
    create: 'Cipta borang',
    creating: 'Mencipta…',
    statusDraft: 'Draf',
    statusPublished: 'Diterbitkan',
    statusArchived: 'Diarkibkan',
    archive: 'Arkib',
    archiveConfirm: 'Arkibkan borang ini?',
    archiving: 'Mengarkibkan…',
    unarchive: 'Nyaharkib',
    filterActive: 'Aktif',
    filterArchived: 'Diarkibkan',
    searchPlaceholder: 'Cari borang',
    sortLabel: 'Isih',
    sortUpdated: 'Dikemas kini terkini',
    sortName: 'Nama',
    sortStatus: 'Status',
    noMatchTitle: 'Tiada borang sepadan',
    noMatchBody: 'Cuba carian lain.',
    meta: {
      updated: 'Dikemas kini {{time}}',
      fieldCount_one: '{{count}} medan',
      fieldCount_other: '{{count}} medan',
      targetNew: 'Lapisan baharu',
      targetExisting: 'Lapisan sedia ada',
    },
    loadError: 'Gagal memuatkan borang',
    actionError: 'Tindakan gagal',
    archivedEmptyTitle: 'Tiada borang diarkibkan',
    archivedEmptyBody: 'Borang yang anda arkibkan akan muncul di sini.',
    nameLabel: 'Tajuk',
    edit: 'Sunting',
    common: {
      yes: 'Ya',
      no: 'Tidak',
    },
    submissions: {
      openOnMap: 'Buka pada peta',
      targetReplaced: 'Baris peta diganti',
      targetReplacedHint:
        'Data lapisan telah diganti selepas maklum balas ini disimpan, jadi barisnya pada peta sudah tiada. Maklum balas itu sendiri disimpan.',
      backToForms: 'Kembali ke borang',
      title: 'Penghantaran',
      viewResponses: 'Maklum balas',
      subtitle: 'Maklum balas yang dikumpulkan oleh borang ini',
      empty: 'Tiada penghantaran lagi',
      emptyBody: 'Maklum balas akan dipaparkan di sini sebaik sahaja orang mula mengisi borang ini.',
      loadError: 'Tidak dapat memuatkan penghantaran',
      loadMore: 'Muat lagi',
      count_one: '{{count}} maklum balas',
      count_other: '{{count}} maklum balas',
      filterStatus: 'Status',
      filterAll: 'Semua',
      noMatch: 'Tiada penyerahan sepadan dengan penapis ini.',
      anonymous: 'Tanpa nama',
      unknownUser: 'Pengguna tidak diketahui',
      deletedUser: '(dipadam)',
      view: 'Lihat',
      delete: 'Padam',
      retry: 'Cuba semula',
      col: {
        submitted: 'Dihantar',
        by: 'Oleh',
        featureId: 'ID Ciri',
        action: 'Tindakan',
        status: 'Status',
        actions: 'Tindakan',
      },
      action: {
        create: 'Dicipta',
        update: 'Disunting',
        delete: 'Dipadam',
      },
      statusLabel: {
        committed: 'Disahkan',
        pending: 'Menunggu',
        failed: 'Gagal',
        orphaned: 'Terbiar',
      },
      detail: {
        title: 'Penghantaran',
        close: 'Tutup',
        fields: 'Medan',
        geometry: 'Geometri',
        noGeometry: 'Tiada geometri',
        rawPayload: 'Muatan mentah',
        download: 'Muat turun',
        noFile: 'Tiada fail',
        targetError: 'Sebab ia tidak disimpan ke lapisan',
      },
      deleteConfirm: {
        title: 'Padam penghantaran?',
        body: 'Ini juga akan membuang ciri daripada lapisan sasaran. Tindakan ini tidak boleh dibatalkan.',
        bodyReplaced:
          'Ini hanya membuang maklum balas. Baris petanya telah diganti semasa data lapisan diganti, jadi tiada apa-apa yang berubah pada peta. Tindakan ini tidak boleh dibatalkan.',
        confirm: 'Padam',
        cancel: 'Batal',
        error: 'Tidak dapat memadam penghantaran',
      },
      retryDialog: {
        title: 'Cuba simpan respons ini semula?',
        bodyRejected:
          'Lapisan menolak respons ini semasa ia dihantar. Jawapan yang disimpan akan ditulis ke lapisan sekali lagi, disemak berdasarkan borang seperti sekarang.',
        warningUnknown:
          'Respons ini mungkin sudah ada dalam lapisan: percubaan sebelumnya tidak pernah mengesahkan sama ada ia telah disimpan. Mencuba semula mungkin mencipta ciri pendua, dan pendua tidak boleh dicari dan dibuang secara automatik. Semak lapisan dahulu.',
        confirm: 'Cuba semula',
        confirmAnyway: 'Cuba semula juga',
        cancel: 'Batal',
        error: 'Tidak dapat mencuba semula respons',
        definitionChanged:
          'Borang telah berubah sejak respons ini dihantar, jadi jawapan yang disimpan tidak lagi lulus:',
        definitionChangedHint: 'Ubah borang supaya jawapan ini sesuai, atau padam respons ini.',
        attachmentMissing:
          'Foto atau fail yang dimuat naik oleh respons ini tidak lagi disimpan, jadi ia tidak boleh ditulis semula.',
        refusedAgain: 'Lapisan menolak respons ini sekali lagi. Buka respons untuk melihat sebabnya.',
        outcomeUnknown:
          'Percubaan sebelumnya untuk respons ini tidak lagi dapat disahkan. Baca amaran sebelum anda mencuba semula.',
      },
      retryNotice: {
        committed: 'Respons telah disimpan ke lapisan.',
        pending:
          'Lapisan tidak mengesahkan penulisan. Ia mungkin telah disimpan: semak lapisan sebelum anda mencuba semula.',
      },
      edit: {
        title: 'Sunting penghantaran',
        loading: 'Memuatkan ciri semasa…',
        loadError: 'Tidak dapat memuatkan ciri semasa',
        cancel: 'Batal',
        retry: 'Cuba lagi',
        conflictTitle: 'Penghantaran ini telah berubah',
        conflictBody:
          'Seseorang lain telah menyunting ciri ini sejak anda membukanya. Muat semula untuk mendapatkan yang terkini, kemudian gunakan semula perubahan anda.',
        reload: 'Muat semula',
        save: 'Simpan perubahan',
        saving: 'Menyimpan…',
      },
    },
    builder: {
      backToForms: 'Borang',
      changedElsewhere:
        'Borang ini telah diubah di tempat lain. Suntingan anda yang belum disimpan dikekalkan; muat semula untuk melihat perubahan lain.',
      reload: 'Muat semula',
      reloadConfirm: 'Buang suntingan anda yang belum disimpan dan muat borang yang telah diubah?',
      save: 'Simpan',
      saving: 'Menyimpan…',
      saved: 'Disimpan',
      loadError: 'Gagal memuatkan borang',
      tabEdit: 'Sunting',
      tabPreview: 'Pratonton',
      panePalette: 'Medan',
      paneCanvas: 'Borang',
      paneSettings: 'Tetapan',
      blockingBanner: 'Betulkan {{count}} isu sebelum menyimpan',
      emptyCanvas: 'Tambah medan dari palet untuk mula membina',
      previewSubmit: 'Hantar (pratonton sahaja)',
      addField: 'Tambah medan',
      deleteField: 'Padam medan',
      moveFieldUp: 'Alih {{label}} ke atas',
      moveFieldDown: 'Alih {{label}} ke bawah',
      fieldMoved: '{{label}} dialihkan ke kedudukan {{position}} daripada {{total}}',
      nameRequired: 'Beri tajuk kepada borang sebelum menyimpan atau menerbitkan',
      saveFailed: 'Perubahan anda tidak disimpan. Suntingan anda masih ada di sini.',
      saveFailedNotPublished:
        'Perubahan anda tidak disimpan, jadi borang tidak diterbitkan. Suntingan anda masih ada di sini.',
      saveErrorGeneric: 'Pelayan tidak memberikan sebab. Semak sambungan anda dan cuba lagi.',
      columnsAdded_one: '{{count}} lajur ditambah pada lapisan',
      columnsAdded_other: '{{count}} lajur ditambah pada lapisan',
    },
    palette: {
      heading: 'Medan',
      text: 'Teks pendek',
      textarea: 'Teks panjang',
      integer: 'Integer',
      decimal: 'Perpuluhan',
      boolean: 'Ya / Tidak',
      date: 'Tarikh',
      selectOne: 'Pilihan tunggal',
      selectMultiple: 'Pilihan berbilang',
      photo: 'Foto',
      file: 'Fail',
      location: 'Lokasi',
    },
    config: {
      heading: 'Tetapan medan',
      label: 'Label',
      autoLabel: 'Menggunakan label automatik: «{{label}}»',
      autoLabelTag: 'Auto',
      name: 'Nama medan',
      nameHint: 'Huruf kecil, digit dan garis bawah; mesti bermula dengan huruf',
      lockedAfterPublish: 'Dikunci selepas diterbitkan',
      reservedColumnName: "Lapisan ini menggunakan '{{name}}' untuk lajurnya sendiri. Beri medan ini nama lain.",
      required: 'Diperlukan',
      booleanAlwaysAnswered:
        'Medan Ya / Tidak sentiasa mempunyai jawapan: jika tidak disentuh, ia dikira sebagai Tidak.',
      helpText: 'Teks bantuan',
      placeholder: 'Pemegang tempat',
      defaultValue: 'Nilai lalai',
      geometryType: 'Jenis geometri',
      geometryPoint: 'Titik',
      geometryLine: 'Garisan',
      geometryPolygon: 'Poligon',
      geometryLockedTo: 'Dikunci kepada lapisan sasaran ({{geometry}})',
      mapsToColumn: 'Petakan ke lajur',
      mapsToColumnPlaceholder: 'Pilih lajur…',
      mapsToColumnHint: 'Lajur lapisan sasaran yang ditulis oleh medan ini.',
      mapsToColumnLoading: 'Memuatkan lajur…',
      mapsToColumnError: 'Tidak dapat memuatkan skema lapisan.',
      mapsToColumnNone: 'Tiada lajur serasi pada lapisan sasaran untuk jenis medan ini.',
      notNull: 'TIDAK NULL',
      options: 'Pilihan',
      addOption: 'Tambah pilihan',
      optionValue: 'Nilai',
      optionLabel: 'Label',
      validationHeading: 'Pengesahan',
      min: 'Min',
      max: 'Maks',
      minLength: 'Panjang minimum',
      maxLength: 'Panjang maksimum',
      pattern: 'Corak (regex)',
      logicHeading: 'Logik bersyarat',
      addRule: 'Tambah peraturan',
      ruleAction: 'Tindakan',
      actionShow: 'Tunjukkan medan ini',
      actionHide: 'Sembunyikan medan ini',
      actionRequire: 'Wajibkan medan ini',
      ruleMatch: 'apabila',
      matchAll: 'semua daripada',
      matchAny: 'mana-mana daripada',
      addCondition: 'Tambah syarat',
      conditionField: 'Medan',
      conditionOp: 'Syarat',
      conditionValue: 'Nilai',
      removeOption: 'Buang pilihan',
      removeRule: 'Buang peraturan',
      removeCondition: 'Buang syarat',
      pickValue: 'Pilih nilai…',
      neverMatches: {
        boolean: 'Nilai ini tidak akan sepadan. Pilih Ya atau Tidak.',
        option: 'Nilai ini tidak akan sepadan. Pilih salah satu pilihan.',
        number: 'Nilai ini tidak akan sepadan. Masukkan nombor.',
        date: 'Nilai ini tidak akan sepadan. Pilih tarikh.',
      },
      ruleMalformed:
        'Peraturan ini rosak, jadi ia mungkin tidak berfungsi seperti yang ditunjukkan. Sunting atau buang peraturan ini.',
      rulesMalformed: 'Peraturan medan ini rosak dan diabaikan. Menambah peraturan akan menggantikannya.',
    },
    settings: {
      heading: 'Tetapan borang',
      name: 'Tajuk',
      description: 'Penerangan',
      sharingOwner: 'Saya sahaja',
      sharingOrganization: 'Organisasi saya',
      sharingGroups: 'Kumpulan tertentu',
      sharingPublic: 'Awam',
    },
    op: {
      eq: 'sama dengan',
      neq: 'tidak sama dengan',
      gt: 'lebih besar daripada',
      lt: 'lebih kecil daripada',
      gte: 'sekurang-kurangnya',
      lte: 'paling banyak',
      contains: 'mengandungi',
      empty: 'kosong',
      not_empty: 'tidak kosong',
    },
    fill: {
      submit: 'Hantar',
      submitting: 'Menghantar…',
      loading: 'Memuatkan…',
      loadError: 'Borang ini tidak tersedia.',
      requiredLegend: 'menandakan medan yang diperlukan',
      successTitle: 'Terima kasih',
      successDefault: 'Respons anda telah direkodkan.',
      submitAnother: 'Hantar respons lain',
      anonymousNotice: 'Anda boleh menghantar borang ini tanpa log masuk.',
      submittingAs: 'Menghantar sebagai {{name}}',
      poweredBy: 'Dikuasakan oleh Gisify',
      privacyNote: 'Respons anda dihantar kepada pemilik borang.',
      networkError: 'Tidak dapat menghantar — sila semak sambungan anda dan cuba lagi.',
      submitFailed: 'Respons anda tidak dapat disimpan. Sila cuba lagi kemudian, atau hubungi pemilik borang.',
      submitPending: 'Kami tidak dapat mengesahkan bahawa respons anda telah disimpan. Sila cuba lagi sebentar lagi.',
      signInRequired: 'Borang ini memerlukan log masuk untuk menghantar. Sila log masuk untuk meneruskan.',
      signInToOpen: 'Log masuk untuk membuka borang ini',
      notAccepting: 'Borang ini tidak menerima respons buat masa ini.',
      signIn: 'Log masuk',
      invalidSummary: '{{count}} medan memerlukan perhatian',
      validation: {
        wholeNumber: '{{label}} mestilah nombor bulat',
        number: '{{label}} mestilah nombor',
        required: '{{label}} wajib diisi',
        atLeast: '{{label}} mestilah sekurang-kurangnya {{limit}}',
        atMost: '{{label}} mestilah tidak melebihi {{limit}}',
        minLength_one: '{{label}} mestilah sekurang-kurangnya {{count}} aksara',
        minLength_other: '{{label}} mestilah sekurang-kurangnya {{count}} aksara',
        maxLength_one: '{{label}} mestilah tidak melebihi {{count}} aksara',
        maxLength_other: '{{label}} mestilah tidak melebihi {{count}} aksara',
        pattern: '{{label}} tidak sepadan dengan format yang diperlukan',
        outOfRange: '{{label}} di luar julat yang dibenarkan',
        yesNo: '{{label}} mestilah Ya atau Tidak',
        invalidOption: '{{label}} mempunyai jawapan yang bukan salah satu pilihannya',
        geometryPoint: '{{label}} mestilah titik',
        geometryLine: '{{label}} mestilah garisan',
        geometryPolygon: '{{label}} mestilah kawasan',
        geometryBounds: '{{label}} berada di luar julat yang sah (longitud -180 hingga 180, latitud -90 hingga 90)',
      },
      draft: {
        notice:
          'Anda mempunyai draf borang ini yang belum disimpan. Pulihkannya untuk menyambung di tempat anda berhenti.',
        restore: 'Pulihkan draf',
        discard: 'Buang draf',
      },
      capture: {
        empty: 'Tiada lokasi ditetapkan',
        setLocation: 'Tetapkan di peta',
        editLocation: 'Sunting di peta',
        clear: 'Kosongkan',
        done: 'Selesai',
        cancel: 'Batal',
        close: 'Tutup',
        redraw: 'Lukis semula',
        useMyLocation: 'Guna lokasi saya',
        accuracy: '±{{meters}} m',
        gpsError: 'Tidak dapat lokasi anda. Cuba lagi atau tetapkan pada peta.',
        pointSet: 'Titik ditetapkan',
        lineSet_one: 'Garisan · {{count}} bucu',
        lineSet_other: 'Garisan · {{count}} bucu',
        polygonSet_one: 'Kawasan · {{count}} bucu',
        polygonSet_other: 'Kawasan · {{count}} bucu',
        instructionsPoint: 'Ketik peta untuk meletakkan titik.',
        instructionsLine: 'Ketik untuk menambah titik; klik dua kali untuk menamatkan garisan.',
        instructionsPolygon: 'Ketik untuk menambah titik; klik dua kali untuk menutup kawasan.',
      },
      upload: {
        choose: 'Pilih fail',
        replace: 'Ganti',
        remove: 'Buang',
        uploading: 'Memuat naik…',
        progress: '{{percent}}%',
        tooLarge: 'Fail terlalu besar (maksimum 25 MB)',
        notAllowed: 'Jenis fail ini tidak dibenarkan',
        failed: 'Muat naik gagal — cuba lagi',
        noFile: 'Tiada fail',
        attachedFile: 'Fail dilampirkan',
        attachedFileWithType: 'Fail dilampirkan ({{ext}})',
      },
    },
    collect: {
      title: 'Borang',
      loading: 'Memuatkan borang…',
      error: 'Tidak dapat memuatkan borang.',
      empty: 'Tiada borang pengumpulan data untuk lapisan pada peta ini.',
      submit: 'Hantar',
      successTitle: 'Respons direkodkan',
      successBody: 'Ciri telah ditambah ke lapisan.',
      fillAnother: 'Isi lagi',
      backToList: 'Kembali ke borang',
    },
    target: {
      heading: 'Sasaran penerbitan',
      engine: 'Sumber data',
      server: 'Sambungan',
      noServers: 'Tiada sambungan dijumpai. Tambah satu di Tetapan → Pelayan.',
      managedDatabase: 'Pangkalan data awan Gisify',
      managedHint: 'Lapisan borang ini akan dicipta dalam pangkalan data awan Gisify terurus anda.',
      mode: 'Ke mana penyerahan pergi?',
      newTable: 'Cipta lapisan baharu',
      existingLayer: 'Guna lapisan sedia ada',
      layer: 'Lapisan',
      noLayers: 'Tiada lapisan dijumpai untuk sambungan ini.',
      geometryLocked: 'Jenis geometri mengikut lapisan sasaran.',
      lockedHint: 'Sasaran penerbitan tidak boleh diubah selepas diterbitkan.',
      editableLayersOnly: 'Hanya lapisan yang boleh anda sunting disenaraikan.',
      layerWriteForbidden:
        'Anda memerlukan akses sunting kepada lapisan ini untuk mengumpul respons borang ke dalamnya.',
      layerNotEditable:
        'Penyuntingan dimatikan untuk lapisan ini. Minta pentadbir menghidupkannya, atau pilih lapisan lain.',
      columnMapping: 'Petakan medan ke lajur',
      mapColumnFor: 'Lajur untuk "{{field}}"',
      auditColumns: 'Tambah lajur atribusi giscenter_* ke lapisan',
      auditColumnsHint: 'Merekodkan siapa yang menghantar setiap ciri, dalam lapisan GIS anda.',
      engineTag: {
        postgresql: 'PostgreSQL',
        arcgis_online: 'ArcGIS Online',
        arcgis_enterprise: 'ArcGIS Enterprise',
        geoserver: 'GeoServer',
      },
      geoserverExistingOnly: 'Borang GeoServer menghantar ke lapisan sedia ada.',
      schemaLoading: 'Memuatkan lajur lapisan…',
      schemaError: 'Tidak dapat memuatkan skema lapisan.',
      schemaReady: '{{count}} lajur tersedia pada lapisan sasaran',
      schemaReady_other: '{{count}} lajur tersedia pada lapisan sasaran',
      save: 'Simpan sasaran',
      cancel: 'Batal',
    },
    publish: {
      publish: 'Terbitkan',
      republish: 'Terbitkan semula',
      publishing: 'Menerbitkan…',
      published: 'Diterbitkan',
      setTargetFirst: 'Pilih sasaran penerbitan dahulu',
      confirmAuditTitle: 'Tambah lajur atribusi?',
      confirmAuditBody: 'Ini akan menambah {{count}} lajur giscenter_* ke lapisan sasaran.',
      confirm: 'Tambah lajur dan terbitkan',
      openForm: 'Buka borang',
      copyLink: 'Salin pautan',
      copied: 'Disalin',
      publishError: 'Penerbitan gagal',
    },
    share: {
      title: 'Kongsi borang',
      tabLink: 'Pautan',
      tabQr: 'QR',
      tabEmbed: 'Benam',
      tabAccess: 'Akses',
      linkLabel: 'Pautan borang',
      copy: 'Salin',
      copied: 'Disalin',
      qrHint: 'Imbas untuk membuka borang di telefon.',
      qrDownload: 'Muat turun QR',
      embedLabel: 'Kod benam',
      embedHint: 'Tampal ini ke dalam laman web untuk membenamkan borang.',
      embedPublicOnly:
        'Borang terbenam hanya berfungsi untuk borang awam. Pelawat tidak boleh log masuk di dalam benaman.',
      accessHint: {
        owner: 'Hanya anda boleh membuka pautan ini',
        organization: 'Ahli organisasi anda yang telah log masuk',
        groups: 'Ahli kumpulan yang dipilih',
        public: 'Sesiapa sahaja yang mempunyai pautan',
      },
      changeAccess: 'Tukar akses',
      accessLevel: 'Siapa boleh akses',
      allowAnonymous: 'Benarkan penghantaran tanpa nama',
      anonymousHint: 'Hanya borang awam boleh menerima penghantaran tanpa nama.',
      save: 'Simpan',
      saving: 'Menyimpan…',
      saveError: 'Tidak dapat mengemas kini perkongsian',
      groupsLabel: 'Kongsi dengan kumpulan',
      groupsEmpty: 'Tiada kumpulan tersedia. Cipta kumpulan dalam Tetapan dahulu.',
      groupsRequired: 'Pilih sekurang-kurangnya satu kumpulan.',
    },
  },
  alerts: {
    // Flat keys for the robot_alerts dashboard element (Slice 6). Nested keys
    // below are Slice 5's; `empty` stays the {title,body} object.
    sos: {
      title: 'Kecemasan',
      missedCount_one: '{{count}} kecemasan terlepas',
      missedCount_other: '{{count}} kecemasan terlepas',
      missedAgo: 'Terlepas · {{when}}',
      missedHint:
        'Tiada sesiapa menjawabnya tepat pada masanya. Ia masih terbuka — hubungi semula atau abaikan setiap satu.',
      callBack: 'Hubungi semula',
      dismiss: 'Abaikan',
      handledElsewhere: '{{label}} telah dijawab di tempat lain.',
      callBusy: 'Tiada panggilan dibuat — panggilan kecemasan lain sedang berjalan.',
      unknownDevice: 'Peranti tidak dikenali',
      waiting_one: '{{count}} lagi kecemasan menunggu',
      waiting_other: '{{count}} lagi kecemasan menunggu',
      accept: 'Terima',
      acceptAndCall: 'Terima & panggil',
      decline: 'Tolak',
      failed: 'Jawapan anda tidak dapat direkodkan. Cuba lagi.',
      call: {
        title: 'Panggilan kecemasan',
        with: 'Memanggil {{name}}',
        dismiss: 'Tutup',
        starting: 'Menyediakan mikrofon anda…',
        ringing: 'Menghubungi helmet…',
        connected: 'Bersambung',
        idle: '',
        mute: 'Senyapkan',
        unmute: 'Nyahsenyap',
        muted: 'Mikrofon anda dimatikan',
        callAction: 'Panggil',
        callName: 'Panggil {{name}}',
        unanswered: 'Helmet ini tidak menjawab panggilan yang lalu.',
        retryUnanswered: 'Topi keledar ini tidak menjawab panggilan terakhir. Panggil {{name}} sekali lagi?',
        busy: 'Satu panggilan lain sedang berlangsung.',
        micDevice: 'Mikrofon',
        micDefault: 'Lalai sistem',
        settings: 'Tetapan panggilan',
        micLevel: 'Aras',
        micGain: 'Peningkatan mikrofon',
        micSilent:
          'Mikrofon anda menghantar senyap — pemakai tidak dapat mendengar anda. Semak peranti input dalam tetapan sistem anda.',
        hangUp: 'Tamatkan',
        ended: {
          hung_up: 'Panggilan tamat.',
          idle: 'Panggilan tamat masa.',
          max: 'Panggilan mencapai had masa.',
        },
        failed: {
          unanswered: 'Helmet tidak menjawab. Ia mungkin tidak menyokong panggilan.',
          mic_denied: 'Akses mikrofon disekat. Benarkan dan cuba lagi.',
          mic_failed: 'Mikrofon anda tidak dapat dibuka.',
          mic_unavailable: 'Tiada mikrofon tersedia.',
          no_broker_ack: 'Panggilan tidak pernah diakui oleh pelayan. Ia mungkin tidak disediakan untuk panggilan.',
          offline: 'Helmet ini tidak bersambung.',
          channel_lost: 'Sambungan ke helmet terputus.',
          connection_lost: 'Panggilan terputus.',
          publish_failed: 'Mikrofon anda tidak dapat sampai ke panggilan.',
          media_failed: 'Tidak dapat menerima audio pemakai.',
          media_timeout: 'Audio pemakai tidak pernah tiba. Mereka mungkin juga tidak dapat mendengar anda.',
          call_gone: 'Panggilan sudah tamat.',
          calls_unavailable: 'Panggilan tidak tersedia pada pemasangan ini.',
          calls_not_configured: 'Panggilan belum disediakan pada pemasangan ini. Hubungi pentadbir anda.',
          device_unidentified: 'Helmet belum selesai menyambung. Cuba lagi sebentar.',
          not_prepared: 'Panggilan tidak disediakan. Cuba lagi.',
          forbidden_role: 'Akaun anda tidak boleh membuat panggilan. Hubungi pentadbir.',
          rejected: 'Panggilan ditolak.',
          failed: 'Panggilan tidak dapat dibuat.',
        },
      },
    },
    log: {
      summary: '{{open}} terbuka · {{entries}} entri',
      pictures_one: '{{count}} gambar',
      pictures_other: '{{count}} gambar',
      pictureTaken: 'Gambar diambil',
      pictureTimeHint: 'Masa gambar sampai ke pelayan. Peranti tidak melaporkan bila pengatup ditekan.',
      viewPicture: 'Lihat gambar',
      pictureUnavailable: 'Gambar ini tidak dapat dimuatkan',
      timedOut: 'Tiada laporan lagi',
      missed: 'Terlepas',
      timedOutHint: 'Penggera ini tidak dilaporkan lebih lima minit, jadi ia tidak lagi mengganggu. Ia masih terbuka.',
      repeatsSince: '{{count}}× sejak {{time}}',
      showRepeats: 'Tunjuk semua',
      hideRepeats: 'Sembunyikan ulangan',
      earlier_one: '{{count}} kejadian terdahulu tidak disenaraikan',
      earlier_other: '{{count}} kejadian terdahulu tidak disenaraikan',
      showOnMap: 'Tunjuk pada peta',
      noLocation: 'Tiada lokasi',
      locationOfLatest: 'Lokasi kejadian terkini bagi amaran ini',
      helmet: 'Topi keledar',
      tracker: 'Penjejak',
      truncated: 'Menunjukkan {{shown}} entri terbaharu daripada {{total}}',
      serverCap: 'Pelayan menyimpan {{count}} amaran dan gambar terbaharu; yang lebih lama tidak disenaraikan.',
      loadFailed: 'Tidak dapat memuatkan sejarah amaran.',
      retry: 'Cuba lagi',
    },
    status: {
      acknowledged: 'Diakui',
      resolved: 'Selesai',
    },
    paletteLabel: 'Amaran Robot',
    paletteDescription: 'Peti masuk amaran robot terbuka',
    scopeFleet: 'Seluruh armada',
    scopeRobot: 'Robot tunggal',
    ack: 'Akui',
    resolve: 'Selesai',
    filtered: 'ditapis',
    empty: {
      title: 'Tiada amaran lagi',
      body: 'Amaran dan gambar akan dipaparkan di sini apabila diterima.',
    },
    actions: {
      enroll: 'Daftar',
      clearAll: 'Kosongkan pin peta',
    },
    clearAll: {
      confirmTitle: 'Kosongkan semua pin peta?',
      confirmBody:
        'Selesaikan setiap amaran terbuka dalam skop ini supaya pin petanya dikeluarkan — termasuk yang tidak disenaraikan di sini. Tiada apa-apa dikeluarkan daripada log ini.',
      confirmCta: 'Kosongkan pin',
      cancel: 'Batal',
    },
    errors: {
      clearAllFailed: 'Tidak dapat mengosongkan amaran. Sila cuba lagi.',
    },
    bell: {
      open: 'Buka amaran',
    },
    drawer: {
      title: 'Amaran robot',
      close: 'Tutup',
    },
  },
  deviceList: {
    loading: 'Memuatkan peranti…',
    selectDevice: 'Pilih peranti',
    tick: 'Tandakan',
    tickGroup: 'Tandakan setiap peranti dalam',
    ticked: '{{count}} ditanda',
    clearTicks: 'Kosongkan',
    otherDevices: 'Peranti lain',
    unnamedGroup: 'Kumpulan tanpa nama',
    groupEmpty: 'Tiada peranti tersedia dalam kumpulan ini',
    empty: {
      title: 'Tiada peranti',
      body: 'Peranti yang didaftarkan ke armada anda akan muncul di sini.',
    },
    emptyChosen: {
      title: 'Tiada peranti yang dipilih tersedia',
      body: 'Pilih peranti untuk dipaparkan dalam Tetapan elemen ini.',
    },
  },
  helmetWall: {
    lightOn: 'Lampu hidup',
    lightOff: 'Lampu mati',
    torchHint: 'Hidupkan atau matikan lampu topi keledar',
    laserOn: 'Laser hidup',
    laserOff: 'Laser mati',
    laserHint: 'Hidupkan atau matikan penunjuk laser topi keledar',
    dblclickFocus: 'Klik dua kali untuk fokus',
    dblclickGrid: 'Klik dua kali untuk kembali ke grid',
    fromList: 'Ditanda dalam senarai peranti',
    photo: 'Foto',
    record: 'Rakam',
    stopRecording: 'Henti rakam',
    focus: 'Fokus',
    unfocus: 'Grid',
    stopLive: 'Henti siaran',
    startLive: 'Mula siaran',
    removeHint: 'Keluarkan topi keledar ini dari dinding',
    paused: 'Siaran langsung dihentikan. Tekan Mula siaran untuk menonton semula.',
    mbps: '{{mbps}} Mbit/s',
    bulk: {
      selectAll: 'Pilih semua',
      selected: '{{count}} dipilih',
      photo: 'Ambil foto',
      recordStart: 'Mula rakam',
      recordStop: 'Henti rakam',
      liveStart: 'Mula siaran',
      liveStop: 'Henti siaran',
      clear: 'Kosongkan',
      result: {
        queued: 'Dalam giliran',
        sent: 'Dihantar',
        photo: 'Foto diterima',
        recording: 'Merakam',
        stopped: 'Dihentikan',
        live: 'Langsung',
        unconfirmed: 'Belum disahkan',
        offline: 'Luar talian',
        refused: 'Ditolak ({{code}})',
        notSent: 'Tidak dihantar',
      },
    },
    selectTile: 'Pilih {{name}}',
    missing: 'Topi keledar ini tidak lagi berdaftar.',
    offline: 'Luar talian — video bermula apabila topi keledar bersambung semula.',
    preview: 'Video langsung dijeda dalam pembina.',
    onCall: 'Sedang dalam panggilan — kamera kembali apabila panggilan tamat.',
    privacy: 'Mod privasi — pemakai telah menjeda kamera.',
    count: '{{online}} daripada {{shown}} dalam talian',
    layout: 'Susun atur',
    add: 'Tambah topi keledar',
    noHelmets: 'Tiada topi keledar berdaftar untuk organisasi ini.',
    empty: 'Tiada topi keledar pada dinding ini. Gunakan Tambah topi keledar untuk membawanya kembali.',
    badge: {
      fall: 'Jatuh',
      electric: 'Elektrik',
      alarm: 'Amaran',
      unanswered: 'Belum dijawab — akui atau selesaikan dalam senarai amaran',
      sos: 'SOS',
      worn: 'Dipakai',
      notWorn: 'Tidak dipakai',
      rec: 'Rakam',
      onCall: 'Dalam panggilan',
      privacy: 'Privasi',
    },
  },
  tracker: {
    register: {
      open: 'Daftar penjejak',
      title: 'Daftar penjejak',
      close: 'Tutup',
      name: 'Nama',
      imei: 'IMEI',
      server: 'Pelayan PostGIS',
      selectServer: 'Pilih pelayan…',
      model: 'Model (pilihan)',
      sendPeriod: 'Tempoh hantar (saat)',
      cancel: 'Batal',
      submit: 'Daftar',
      submitting: 'Mendaftar…',
      success: 'Penjejak didaftarkan: {{name}}',
      settingsIntro:
        'Dalam Teltonika Configurator, buka GPRS → Server settings, masukkan nilai ini dan simpan ke peranti:',
      done: 'Selesai',
      errors: {
        nameRequired: 'Masukkan nama untuk penjejak ini.',
        imeiInvalid: 'IMEI mesti tepat 15 digit.',
        serverRequired: 'Pilih pelayan PostGIS yang menyimpan kedudukan.',
        sendPeriodInvalid: 'Tempoh hantar mesti nombor bulat saat dari 10 hingga 86400.',
        failed: 'Pendaftaran gagal. Sila cuba lagi.',
      },
      settings: {
        domain: 'Domain pelayan',
        port: 'Port',
        protocol: 'Protokol',
        dataProtocol: 'Protokol data',
        serverConfirmation: 'Pengesahan pelayan',
        unknownHost: 'Tidak dikonfigurasikan pada penempatan ini',
      },
    },
    status: {
      recordedAt: 'Rekod terakhir',
      receivedAt: 'Diterima',
      presenceLabel: 'Kehadiran',
      presence: {
        online: 'Dalam talian',
        stale: 'Lapuk',
        offline: 'Luar talian',
      },
      lastSeen: 'Terakhir dilihat',
      battery: 'Bateri',
      charging: 'Mengecas',
      yes: 'Ya',
      no: 'Tidak',
      batteryMv: 'Voltan bateri',
      gnssStatus: 'GNSS',
      gnss: {
        off: 'Mati',
        fix: 'Ada kedudukan',
        noFix: 'Tiada kedudukan',
        sleep: 'Tidur',
      },
      satellites: 'Satelit',
      hdop: 'HDOP',
      speed: 'Kelajuan',
      heading: 'Arah',
      movement: 'Pergerakan',
      moving: 'Bergerak',
      stationary: 'Pegun',
      gsmSignal: 'Isyarat GSM',
      temperature: 'Suhu',
      operator: 'Pengendali',
      sections: {
        status: 'Status',
        power: 'Kuasa',
        gnss: 'GNSS',
        device: 'Peranti',
      },
      empty:
        'Tiada laporan daripada penjejak ini sejak halaman dibuka. Ia akan muncul dengan rekod seterusnya yang dihantar peranti.',
      selectPrompt: 'Pilih penjejak pada papan pemuka ini untuk melihat statusnya.',
      pickPrompt: 'Pilih penjejak dalam tetapan elemen ini.',
    },
    track: {
      title: 'Jejak',
      start: 'Mula',
      end: 'Tamat',
      clear: 'Kosongkan',
      loading: 'Memuatkan jejak…',
      error: 'Tidak dapat memuatkan jejak.',
      empty: 'Tiada kedudukan dalam tempoh ini.',
      points: '{{count}} titik',
      truncated: '{{count}} titik terkini (had dicapai — titik lebih lama tidak ditunjukkan)',
      preset: {
        '1h': '1j',
        '6h': '6j',
        '24h': '24j',
        '7d': '7h',
      },
    },
    config: {
      title: 'Status penjejak',
      tracker: 'Penjejak',
      select: 'Pilih penjejak…',
      missing: 'Penjejak yang dipilih tiada dalam senarai armada (dibuang, atau masih dimuatkan).',
      follow: 'Ikut pilihan robot',
      followHint:
        'Pada papan pemuka armada, memilih peranti menunjukkan peranti itu dan bukannya penjejak yang dipilih di atas. Apabila dimatikan, jalur ini sentiasa menunjukkan penjejak di atas.',
    },
  },
  geocoding: {
    title: 'Geocoding',
    steps: { source: 'Select Source', fields: 'Map Fields', options: 'Options', review: 'Review' },
    providers: { nominatim: 'Nominatim (OpenStreetMap)', arcgis: 'ArcGIS World Geocoding' },
    status: { processing: 'Processing', completed: 'Completed', failed: 'Failed' },
    wizard: {
      uploadPrompt: 'Klik atau seret fail untuk memuat naik',
      uploadHint: 'Format disokong: CSV, TXT, Excel (.xlsx)',
      reading: 'Memuat naik dan membaca fail…',
      fileLoaded: 'Fail dimuatkan: {{rows}} baris, {{columns}} lajur',
      fileLoadedUnknownRows: 'Fail dimuatkan: {{columns}} lajur (terlalu besar untuk mengira baris dahulu)',
      fileLoadedEstimatedRows: 'Fail dimuatkan: kira-kira {{rows}} baris (anggaran), {{columns}} lajur',
      rowsEstimated: 'Kira-kira {{rows}} baris (anggaran)',
      rowsUnknown: 'Tidak dikira',
      stop: 'Henti',
      stopping: 'Sedang dihentikan…',
      stopFailed: 'Gagal menghentikan larian',
      stoppedTitle: 'Dihentikan pada {{processed}} daripada {{total}}',
      stoppedBody: 'Baris yang telah siap setakat ini disimpan. Kredit yang tidak digunakan telah dikembalikan.',
      resume: 'Sambung semula',
      exportPartial: 'Eksport hasil separa',
      delete: 'Padam',
      deleteTitle: 'Padam larian ini?',
      deleteBody: 'Ini memadam larian dan baris yang telah digeokod setakat ini. Tindakan ini tidak boleh dibatalkan.',
      deleteFailed: 'Gagal memadam larian',
      resumeUnsupported:
        'Larian ini dimulakan sebelum fungsi henti dan sambung semula wujud, jadi ia tidak boleh disambung semula. Eksport apa yang telah siap, atau mulakan semula.',
      resumeNoCredits: 'Kredit tidak mencukupi untuk menyambung semula larian ini. Tambah kredit, kemudian cuba lagi.',
      resumeFailed: 'Gagal menyambung semula larian',
      addressFormat: 'Format Alamat',
      modeConcatenate: 'Gabungan Ringkas',
      modeStructured: 'Pertanyaan Berstruktur',
      selectColumns: 'Pilih lajur untuk digabungkan (mengikut turutan)',
      selectColumnsHelp: 'Lajur akan digabungkan dengan koma untuk membentuk alamat',
      addColumn: 'Tambah',
      moveUp: 'Alihkan {{column}} ke atas',
      moveDown: 'Alihkan {{column}} ke bawah',
      removeColumn: 'Buang {{column}}',
      suffixLabel: 'Akhiran Alamat (pilihan)',
      suffixHelp: "Ditambah pada setiap alamat, cth. 'Malaysia' atau 'Kedah, Malaysia'",
      suffixPlaceholder: 'cth. Malaysia',
      addressPreview: 'Pratonton Alamat',
      noPreview: 'Tiada pratonton tersedia',
      expectedRegionLabel: 'Wilayah/Negeri Dijangka (pilihan)',
      expectedRegionHelp: 'Keputusan dari wilayah lain akan ditandakan sebagai gagal.',
      expectedRegionPlaceholder: 'cth. Kedah, Selangor, Johor',
      previewFailed: 'Tidak dapat membaca fail yang dimuat naik.',
      previewUnavailable:
        'Kami tidak dapat membaca lajur fail ini, jadi tiada apa-apa untuk dipetakan lagi. Fail anda selamat dimuat naik — sila cuba lagi.',
      retryPreview: 'Baca fail semula',
      legacyXlsUnsupported:
        'Fail Excel lama (.xls) tidak disokong. Buka fail dalam Excel dan simpan sebagai .xlsx atau CSV, kemudian muat naik semula.',
    },
    regeocode: {
      inheritedGatesHelp:
        'Dibawa daripada pusingan sebelumnya, bersama sempadannya jika ada. Kosongkan medan ini untuk menggugurkan semakan wilayah bagi pusingan ini.',
    },
  },
  digitize: {
    edit: {
      reshape: 'Bentuk semula geometri',
      undo: 'Buat asal',
      redo: 'Buat semula',
      delete: 'Padam',
      save: 'Simpan',
      reload: 'Muat semula',
      noFields: 'Tiada medan boleh diedit.',
      selectLayer: 'Pilih lapisan boleh diedit untuk mula mengedit.',
      clickFeature: 'Klik ciri pada peta untuk mengeditnya.',
      conflict: 'Ciri ini telah diubah oleh orang lain. Muat semula untuk mendapatkan versi terkini sebelum menyimpan.',
      loadFailed: 'Gagal memuatkan ciri.',
      openFailed: 'Tidak dapat membuka lapisan boleh sunting ini. Ia mungkin telah dipadam, atau anda di luar talian.',
      saveFailed: 'Gagal menyimpan ciri.',
      deleteFailed: 'Gagal memadam ciri.',
    },
    create: {
      title: 'Lapisan boleh diedit baharu',
      namePlaceholder: 'Nama lapisan',
      descriptionPlaceholder: 'Penerangan (pilihan)',
      geometryType: 'Jenis geometri',
      geometryPoint: 'Titik',
      geometryLine: 'Garisan',
      geometryPolygon: 'Poligon',
      fields: 'Medan',
      fieldNamePlaceholder: 'nama_medan',
      fieldType: 'Jenis medan',
      requiredShort: 'wajib',
      requiredAria: 'Medan wajib',
      removeField: 'Buang medan',
      addField: 'Tambah medan',
      managedHint: 'Lapisan ini akan dicipta dalam pangkalan data awan Gisify terurus anda.',
      targetServer: 'Pelayan sasaran',
      selectServer: 'Pilih pelayan…',
      serverHint: 'Lapisan baharu hanya boleh dicipta pada pelayan PostgreSQL atau ArcGIS.',
      cancel: 'Batal',
      createButton: 'Cipta lapisan',
      nameRequired: 'Nama diperlukan',
      createFailed: 'Gagal mencipta lapisan. Sila cuba lagi.',
      duplicateFields: 'Nama medan mesti unik.',
      reservedFields: 'Nama medan ini dikhaskan dan tidak boleh digunakan: {{names}}',
      close: 'Tutup',
      newFeature: 'Ciri baharu',
      saveFeature: 'Simpan ciri',
    },
    schema: {
      title: 'Sunting skema',
      editSchema: 'Sunting skema',
      addField: 'Tambah medan',
      saveSchema: 'Simpan skema',
      saving: 'Menyimpan…',
      cancel: 'Batal',
      unsupportedTarget: 'Penyuntingan skema hanya disokong pada lapisan PostgreSQL dan ArcGIS.',
      notEditable: 'Lapisan ini bukan lapisan digitisasi yang boleh disunting.',
      uniqueNames: 'Nama medan mesti unik.',
      reusedRemovedName:
        'Nama medan yang dibuang tidak boleh digunakan semula dalam suntingan yang sama. Namakan semula sebaliknya.',
      conflictReload: 'Ciri ini telah diubah oleh orang lain. Muat semula dan cuba lagi.',
    },
  },
  library: {
    editing: {
      heading: 'Penyuntingan',
      features: 'Sunting ciri',
      schema: 'Sunting skema',
      on: 'Hidup',
      off: 'Mati',
      freezeNote:
        'Mengaktifkan penyuntingan mengunci lapisan ini pada pelayan dan jadualnya sekarang sehingga penyuntingan dimatikan.',
      adminOnly: 'Hanya pentadbir boleh menukar tetapan ini.',
      saveError: 'Tidak dapat menukar tetapan penyuntingan',
      auditColumns: {
        note: 'Jadual ini tiada lajur atribusi, jadi suntingan hanya direkodkan dalam log audit. Anda boleh menambahkannya ke jadual:',
        add: 'Tambah lajur atribusi',
      },
    },
    replaceConfirm: {
      titleForms: 'Gantikan lapisan yang menyimpan respons borang?',
      title: 'Gantikan data lapisan ini?',
      formsIntro_one: '{{count}} borang mengumpul respons ke dalam lapisan ini:',
      formsIntro_other: '{{count}} borang mengumpul respons ke dalam lapisan ini:',
      formsListLabel: 'Borang yang mengumpul ke dalam lapisan ini',
      moreForms_one: '+{{count}} borang lagi',
      moreForms_other: '+{{count}} borang lagi',
      opensInNewTab: '(dibuka dalam tab baharu)',
      consequencesHeading: 'Jika anda menggantikannya',
      rowsDeleted:
        'Setiap baris yang dikumpul oleh borang ini akan dipadam dan digantikan dengan data baharu. Borang masih menyenaraikan respons tersebut, tetapi baris yang dirujuknya sudah tiada.',
      missingColumn:
        'Jika data baharu tiada lajur yang dipetakan oleh medan borang, borang itu akan gagal pada setiap penghantaran sehingga borang atau lapisan dibetulkan.',
      dataReplaced: 'Data semasa lapisan akan dipadam dan digantikan dengan data baharu.',
      columnsHeading: 'Perubahan lajur',
      columnsAdded: 'Ditambah: {{columns}}',
      columnsRemoved: 'Dibuang: {{columns}}',
      columnsRetyped: 'Jenis diubah: {{columns}}',
      geometryChanged: 'Geometri berubah daripada {{from}} kepada {{to}}',
      geometryNone: 'tiada',
      layersAdded: 'Lapisan ditambah: {{layers}}',
      layersRemoved: 'Lapisan dibuang: {{layers}}',
      noColumnChanges: 'Tiada perubahan lajur',
      styleHeading: 'Gaya',
      styleColumnsRemoved:
        'Gaya lapisan menggunakan lajur yang tiada dalam data baharu: {{columns}}. Peraturan gaya tersebut tidak akan sepadan lagi.',
      featuresHeading: 'Ciri',
      featureCount: '{{before}} → {{after}}',
      featureCountUnknown: 'tidak diketahui',
      acknowledge: 'Saya faham bahawa data semasa lapisan akan digantikan',
      cancel: 'Batal',
      confirm: 'Gantikan data',
      error: 'Lapisan tidak dapat digantikan.',
    },
    replace: {
      button: 'Gantikan data…',
      disabled: {
        linked: 'Lapisan ini merujuk data yang tidak dicipta oleh Gisify.',
        typeNotReplaceable: 'Data bagi jenis lapisan ini tidak boleh digantikan.',
        missingSource:
          'Lapisan ini diterbitkan sebelum penggantian disokong — terbitkan semula sekali untuk membolehkan penggantian.',
        cloudEngine: 'Penggantian tidak tersedia untuk lapisan pada pelayan ini dalam ruang kerja Gisify Cloud.',
      },
      title: 'Gantikan data: {{name}}',
      intro:
        'Pilih fail yang mengandungi data baharu. Lapisan mengekalkan id, nama, perkongsian dan gayanya; baris datanya digantikan.',
      accepted: 'Fail yang diterima oleh lapisan ini:',
      sameFormat:
        'Lapisan ini diterbitkan daripada fail {{format}}, jadi hanya fail {{format}} boleh menggantikan datanya.',
      fileTypes: {
        csv: 'CSV',
        geojson: 'GeoJSON',
        shapefile: 'Shapefile (.zip)',
        geopackage: 'GeoPackage (.gpkg)',
      },
      dropzone: 'Klik untuk memilih fail, atau seret ke sini',
      chosen: 'Fail dipilih: {{name}}',
      refused: {
        gdb: 'File Geodatabase tidak boleh menggantikan data lapisan. Eksport ke GeoPackage atau shapefile terlebih dahulu.',
        multiShapefile:
          'Zip ini mengandungi lebih daripada satu shapefile. Penggantian memerlukan zip dengan tepat satu shapefile.',
        wrongType: 'Lapisan ini tidak boleh digantikan dengan jenis fail itu.',
        unreadable: 'Fail tidak dapat dibaca: {{reason}}',
      },
      csvCoordinates: 'Pilih lajur latitud dan longitud: lapisan memerlukan lokasi bagi setiap baris.',
      gpkgTable: 'Jadual GeoPackage',
      gpkgTableHint: 'Jadual dalam fail yang mengandungi data baharu.',
      gpkgOneTable: 'GeoPackage mesti mengandungi tepat satu jadual: seluruh fail menggantikan lapisan.',
      gpkgTables: 'Jadual GeoPackage (satu setiap baris)',
      gpkgTablesHint:
        'Senaraikan dua jadual atau lebih. Jadual yang menjadi sumber sesuatu lapisan dalam kumpulan menggantikan lapisan itu. Jadual baharu menambah lapisan; lapisan yang jadualnya tiada akan dibuang.',
      gpkgTablesChooseFile: 'Pilih GeoPackage untuk melihat jadualnya',
      gpkgTablesReading: 'Membaca jadual dalam fail…',
      gpkgTablesInFile: 'Jadual dalam fail ini: {{tables}}',
      gpkgTablesNone: 'GeoPackage ini tidak mengandungi jadual fitur.',
      gpkgTablesUnreadable: 'Jadual dalam fail ini tidak dapat disenaraikan. Taipkannya, satu setiap baris.',
      groupLoading: 'Memuatkan lapisan kumpulan…',
      groupLoadFailed: 'Lapisan kumpulan tidak dapat dimuatkan.',
      groupNotPostgres: 'Hanya kumpulan lapisan yang disimpan dalam PostgreSQL boleh digantikan datanya.',
      check: 'Semak fail',
      cancel: 'Batal',
      close: 'Tutup',
      retry: 'Cuba lagi',
      checking: 'Menyemak fail anda…',
      checkingHint: 'Tiada apa-apa yang berubah lagi. Gisify sedang membandingkan fail dengan lapisan.',
      stale: 'Borang atau lajur lapisan telah berubah sejak semakan. Menyemak semula…',
      staleRechecked: 'Semakan telah dijalankan semula: semak perubahan di bawah.',
      replacing: 'Menggantikan data…',
      replacingHint: 'Anda boleh menutup tetingkap ini. Penggantian akan terus berjalan.',
      inBackground: 'Menggantikan data… Halaman ini akan dikemas kini apabila selesai.',
      done: 'Lapisan dikemas kini',
      doneHint: 'Lapisan mengekalkan id, perkongsian dan gayanya. Data, liputan dan bilangan cirinya adalah baharu.',
      featuresLabel: 'Ciri',
      statusUnknown:
        'Status penggantian tidak dapat dibaca. Ia mungkin masih berjalan; muat semula lapisan dalam seminit.',
      errors: {
        linkedLayer: 'Lapisan ini merujuk data yang tidak dicipta oleh Gisify. Gantikannya di sumbernya.',
        notSupported: 'Fail ini tidak boleh menggantikan data lapisan ini.',
        missingSource:
          'Lapisan ini diterbitkan sebelum penggantian disokong — terbitkan semula sekali untuk membolehkan penggantian.',
        generic: 'Sesuatu tidak kena. Cuba lagi.',
      },
    },
  },
  planning,
} as const
